<template>
  <section class="assessmentSection protectionLevelSection">
    <div class="welcomeBackground"></div>
    <div class="pageContent">
      <div class="pagePretitle">Select a protection level</div>
      <div class="pageTitle">There are 3 ways to protect your home</div>
      <div class="pageText">
        <router-link to="/assessment/help/what-are-protection-levels">Learn more about protection levels</router-link>
      </div>
    </div>
    
    <section class="protectionLevels">
      <!-- Essential -->
      <true-panel @click.native="selectLevel('Essential')" class="protectionLevel" :class="{'selected': lead.protectionLevel == 'Essential'}">
        <div class="protectionLevel-Title">Essential</div>
        <div class="protectionLevel-Cost">$</div>
        <div class="protectionLevel-Subtitle">For those who have minimal security concerns</div>
        <hr>
        <div class="protectionLevel-Features">
          <div class="protectionLevel-Feature">All perimeter doors</div>
          <div class="protectionLevel-Feature">
            Interior motion
            <i>Protects from window <br> entry while you're away</i>
          </div>
        </div>
        <div class="protectionLevel-Select">
          <div v-if="lead.protectionLevel !== 'Essential'">
            <a href="javascript:;" @click="selectLevel('Essential')">Select Essential level</a>
          </div>
          <div v-if="lead.protectionLevel === 'Essential'">
              <img src="/img/checkmark-white.png" alt="Checkmark">
            </div>
        </div>
      </true-panel>
      <!-- END Essential -->
      <!-- ENHANCED -->
      <true-panel @click.native="selectLevel('Enhanced')" class="protectionLevel" :class="{'selected': lead.protectionLevel == 'Enhanced'}">
        <div class="protectionLevel-Title">Enhanced</div>
        <div class="protectionLevel-Cost">$$</div>
        <div class="protectionLevel-Subtitle">
          Essential + <b>Areas of Particular Concern</b>
        </div>
        <hr>
        <div class="protectionLevel-Features">
          <div class="protectionLevel-Feature">All perimeter doors</div>
          <div class="protectionLevel-Feature">Interior motion</div>
          <div class="protectionLevel-Feature">Selective window protection</div>
        </div>
        <div class="protectionLevel-Select">
            <div v-if="lead.protectionLevel !== 'Enhanced'">
              <a href="javascript:;">Select Enhanced level</a>
            </div>
            <div v-if="lead.protectionLevel === 'Enhanced'">
                <img src="/img/checkmark-white.png" alt="Checkmark">
              </div>
        </div>
      </true-panel>
      <!-- END ENHANCED -->
      <!-- TOTAL -->
      <true-panel @click.native="selectLevel('Total')" class="protectionLevel" :class="{'selected': lead.protectionLevel == 'Total'}">
        <div class="protectionLevel-Title">Total</div>
        <div class="protectionLevel-Cost">$$$</div>
        <div class="protectionLevel-Subtitle">
          Essential + <b>Complete Perimeter Protection</b>
        </div>
        <hr>
        <div class="protectionLevel-Features">
          <div class="protectionLevel-Feature">All Perimeter doors</div>
          <div class="protectionLevel-Feature">All points of entry protected</div>
          
        </div>
        <div class="protectionLevel-Select">
            <div v-if="lead.protectionLevel !== 'Total'">
              <a href="javascript:;">Select Total level</a>
            </div>
            <div v-if="lead.protectionLevel === 'Total'">
              <img src="/img/checkmark-white.png" alt="Checkmark">
            </div>
        </div>
      </true-panel>
      <!-- END TOTAL -->
    </section>

    <section class="actions" v-if="lead.protectionLevel">
      <continue-button ref="continueButton" :before="mixpanelTracking" :to="to" />
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
    data: () => ({
      answer: null,
      protectionLevelModalOpen: false,
      level: '',
      to: '/assessment/level-confirmation'
    }),
    computed: {
        ...mapState(["lead"])
    },
    methods: {
        ...mapActions([
            "selectProtectionLevel",
            "getProtectionLevelWarnings",
            "dismissProtectionLevelWarning",
            "dismissProtectionLevelWarnings",
            "toggleModal"
        ]),
        closeModalAndRemoveWarnings() {
            this.toggleModal()
            this.dismissProtectionLevelWarnings()
        },
        selectLevel(level) {
          let that = this
          this.level = level
          this.mixpanelTracking()
          this.selectProtectionLevel(level)
            .then(() => {
              this.$router.push(that.to)
            })
        },
        mixpanelTracking() {
          let level = this.lead.protectionLevel || this.level
          mixpanel.track("choseLevel", {currentLevel: level})
          mixpanel.people.set({currentLevel: level})
        }
    },
    mounted() {
        this.$Progress.set(14)
        gtag('event', 'conversion', {'send_to': 'AW-879819493/V16eCKS3_IIBEOX1w6MD'});
    }
}
</script>
